/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The function which to use when calculating the resource recommendation. QUANTILE - the quantile function. MAX - the max function.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1ResourceConfigFunction = {
    QUANTILE: 'QUANTILE',
    MAX: 'MAX'
} as const;

export type WorkloadoptimizationV1ResourceConfigFunction = typeof WorkloadoptimizationV1ResourceConfigFunction[keyof typeof WorkloadoptimizationV1ResourceConfigFunction];



